import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import gsap from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import LogoSvg from './logoSvg.js';
import styles from './logo.css';

gsap.registerPlugin(DrawSVGPlugin);
gsap.defaults({ ease: 'power3.inOut', duration: 0.6 });

const Logo = ({ setLogoAnimationComplete }) => {
  const logoRef = useRef(null);

  useEffect(() => {
    const logo = logoRef.current;
    const ellipse = logo.querySelector('svg ellipse');

    gsap.fromTo(
      ellipse,
      { drawSVG: 0 },
      {
        drawSVG: '100%',
        delay: 0.25,
        duration: 0.9,
        onComplete: () => setLogoAnimationComplete(true),
      },
    );
  }, [logoRef]);

  return (
    <div ref={logoRef} className={styles.logoWrapper}>
      <h1 className={styles.pageTitle}>Inspiration Nation</h1>
      <LogoSvg />
    </div>
  );
};

Logo.propTypes = {
  setLogoAnimationComplete: PropTypes.func,
};

export default Logo;
